(() => {
  const STORAGE_KEYS = {
    submitted: "waitlist_submitted",
    submittedAt: "waitlist_submitted_at",
    emailHash: "waitlist_email_hash",
    anonymousId: "waitlist_anonymous_id"
  };

const NB_TIMEOUT_MS = 3000;
  const NB_DEBOUNCE_MS = 400;
  const NB_WIDGET_URL = "https://cdn.neverbounce.com/widget/dist/NeverBounce.js";

  const GEO_TIMEOUT_MS = 2000;
  const GEO_URL = "https://ipapi.co/json/";

  function isTouchDevice() {
    try {
      return window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
    } catch (_) {
      return false;
    }
  }

  // ---------- Metadata capture helpers ----------

  function detectDeviceType() {
    const ua = navigator.userAgent || "";
    if (/iPad|Tablet|PlayBook|Silk/i.test(ua) || (/Android/i.test(ua) && !/Mobile/i.test(ua))) return "Tablet";
    if (/Mobi|iPhone|iPod|Android|BlackBerry|IEMobile|Opera Mini/i.test(ua)) return "Mobile";
    return "Desktop";
  }

  function detectBrowser() {
    const ua = navigator.userAgent || "";
    if (/Edg\//.test(ua)) return "Edge";
    if (/OPR\//.test(ua) || /Opera/.test(ua)) return "Opera";
    if (/SamsungBrowser/.test(ua)) return "Samsung Internet";
    if (/Firefox/.test(ua)) return "Firefox";
    if (/Chrome/.test(ua) && !/Chromium/.test(ua)) return "Chrome";
    if (/Safari/.test(ua) && !/Chrome/.test(ua)) return "Safari";
    return "Other";
  }

  function detectOS() {
    const ua = navigator.userAgent || "";
    const platform = (navigator.platform || "").toLowerCase();
    if (/iPhone|iPad|iPod/.test(ua)) return "iOS";
    if (/Android/.test(ua)) return "Android";
    if (/Win/i.test(platform)) return "Windows";
    if (/Mac/i.test(platform)) return "macOS";
    if (/Linux/i.test(platform)) return "Linux";
    return "Other";
  }

  function detectScreenSizeBucket() {
    const w = window.screen && window.screen.width ? window.screen.width : 0;
    if (w < 640) return "Small";
    if (w < 1024) return "Medium";
    if (w < 1440) return "Large";
    return "Extra Large";
  }

  function detectReferrerDomain() {
    try {
      if (!document.referrer) return "Direct";
      const refUrl = new URL(document.referrer);
      if (refUrl.hostname === window.location.hostname) return "Internal";
      return refUrl.hostname;
    } catch (_) {
      return "Unknown";
    }
  }

  function detectLanguage() {
    return navigator.language || (navigator.languages && navigator.languages[0]) || "Unknown";
  }

  function detectUTMs() {
    try {
      const params = new URLSearchParams(window.location.search);
      return {
        source: params.get("utm_source") || "",
        medium: params.get("utm_medium") || "",
        campaign: params.get("utm_campaign") || "",
        term: params.get("utm_term") || "",
        content: params.get("utm_content") || ""
      };
    } catch (_) {
      return { source: "", medium: "", campaign: "", term: "", content: "" };
    }
  }

  function detectSignupTimeBucket() {
    const now = new Date();
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const day = days[now.getDay()];
    const hour = now.getHours();
    let bucket = "";
    if (hour < 6) bucket = "Late night (0-6)";
    else if (hour < 12) bucket = "Morning (6-12)";
    else if (hour < 18) bucket = "Afternoon (12-18)";
    else bucket = "Evening (18-24)";
    return day + " " + bucket;
  }

  function fetchGeolocation() {
    return new Promise((resolve) => {
      const controller = new AbortController();
      const timer = window.setTimeout(() => controller.abort(), GEO_TIMEOUT_MS);
      fetch(GEO_URL, { signal: controller.signal })
        .then((response) => response.ok ? response.json() : null)
        .then((data) => {
          window.clearTimeout(timer);
          if (!data || data.error) { resolve({ country: "", city: "", region: "" }); return; }
          resolve({ country: data.country_name || "", city: data.city || "", region: data.region || "" });
        })
        .catch(() => {
          window.clearTimeout(timer);
          resolve({ country: "", city: "", region: "" });
        });
    });
  }

  function collectMetadata() {
    const utms = detectUTMs();
    return {
      device: detectDeviceType(),
      browser: detectBrowser(),
      os: detectOS(),
      screenSize: detectScreenSizeBucket(),
      referrer: detectReferrerDomain(),
      language: detectLanguage(),
      signupTime: detectSignupTimeBucket(),
      utmSource: utms.source,
      utmMedium: utms.medium,
      utmCampaign: utms.campaign,
      utmTerm: utms.term,
      utmContent: utms.content
    };
  }

  // --- Tracking helpers (GTM dataLayer) ---
  function pushToDataLayer(payload) {
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function generateEventId(prefix) {
    return (prefix || "evt") + "_" + Date.now() + "_" + Math.random().toString(36).slice(2, 10);
  }
  class WaitlistModal {
    constructor(root) {
      this.root = root;
      this.klaviyoKey = root.dataset.klaviyoKey;
      this.klaviyoListId = root.dataset.klaviyoList;
      this.nbPublicKey = root.dataset.nbKey;
      this.teamsWebhook = root.dataset.teamsWebhook;

      this.modal = root.querySelector("[data-waitlist-modal]");
      this.dialog = root.querySelector("[data-waitlist-dialog]");
      this.overlay = root.querySelector("[data-waitlist-overlay]");
      this.form = root.querySelector("[data-waitlist-form]");

      this.submitButton = root.querySelector("[data-waitlist-submit]");
      this.submitLabel = root.querySelector("[data-submit-label]");
      this.submitLoading = root.querySelector("[data-submit-loading]");
      this.submitError = root.querySelector("[data-waitlist-submit-error]");

      this.emailInput = this.form ? this.form.elements.email : null;
      this.emailStatusEl = root.querySelector("[data-email-status]");

      this.statePanels = {
        form: root.querySelector('[data-waitlist-state="form"]'),
        success: root.querySelector('[data-waitlist-state="success"]'),
        already: root.querySelector('[data-waitlist-state="already"]')
      };

      this.isOpen = false;
      this.isSubmitting = false;
      this.lastFocusedElement = null;
      this.scrollY = 0;

      this.nbLoaded = false;
      this.nbLoadingPromise = null;
      this.nbDebounceTimer = null;
      this.nbLastCheckedEmail = null;
      this.nbLastResult = null;

      this.geoData = null;
      this.geoPromise = null;

      this.handleKeydown = this.handleKeydown.bind(this);
    }

    init() {
      if (!this.modal || !this.dialog || !this.form) return;
      this.bindTriggers();
      this.bindModalControls();
      this.bindFormControls();
      this.bindEmailValidation();
    }

    bindTriggers() {
      document.addEventListener("click", (event) => {
        const trigger = event.target.closest("[data-waitlist-open]");
        if (!trigger) return;
        if (event.defaultPrevented) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.open(trigger);
      });
    }

    bindModalControls() {
      if (this.overlay) {
        this.overlay.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
        });
      }

      this.root.querySelectorAll("[data-waitlist-close]").forEach((button) => {
        button.addEventListener("click", () => this.close());
      });

      const resetButton = this.root.querySelector("[data-waitlist-reset]");
      if (resetButton) {
        resetButton.addEventListener("click", () => {
          this.clearSubmissionMemory();
          this.resetForm(true);
          this.showState("form");
          this.focusInitial();
        });
      }
    }

    bindFormControls() {
      this.form.addEventListener("submit", async (event) => {
        event.preventDefault();
        await this.submit();
      });

      this.form.addEventListener("input", (event) => {
        const fieldName = event.target && event.target.name;
        if (fieldName) this.clearFieldError(fieldName);
      });
    }

    bindEmailValidation() {
      if (!this.emailInput) return;

      this.emailInput.addEventListener("input", () => {
        if (this.nbDebounceTimer) {
          window.clearTimeout(this.nbDebounceTimer);
          this.nbDebounceTimer = null;
        }
        this.nbLastResult = null;
        this.setEmailStatus("", "");
      });

      this.emailInput.addEventListener("blur", () => {
        this.scheduleEmailCheck(0);
      });
    }

    scheduleEmailCheck(delayMs) {
      if (!this.emailInput || !this.nbPublicKey) return;
      if (this.nbDebounceTimer) window.clearTimeout(this.nbDebounceTimer);
      this.nbDebounceTimer = window.setTimeout(
        () => this.runEmailCheck(),
        typeof delayMs === "number" ? delayMs : NB_DEBOUNCE_MS
      );
    }

    runEmailCheck() {
      const email = String(this.emailInput.value || "").trim().toLowerCase();
      if (!email) return;
      if (!this.emailInput.checkValidity()) return;
      if (email === this.nbLastCheckedEmail) return;

      this.nbLastCheckedEmail = email;
      this.setEmailStatus("checking", "");

      this.loadNeverBounce()
        .then(() => this.verifyEmail(email))
        .then((result) => {
          const currentEmail = String(this.emailInput.value || "").trim().toLowerCase();
          if (currentEmail !== email) return;
          this.handleNBResult(result);
        })
        .catch(() => {
          const currentEmail = String(this.emailInput.value || "").trim().toLowerCase();
          if (currentEmail !== email) return;
          this.nbLastResult = "unknown";
          this.setEmailStatus("", "");
        });
    }

    loadNeverBounce() {
      if (this.nbLoaded) return Promise.resolve();
      if (this.nbLoadingPromise) return this.nbLoadingPromise;
      if (!this.nbPublicKey) return Promise.reject(new Error("No NeverBounce key"));

      this.nbLoadingPromise = new Promise((resolve, reject) => {
        window._NBSettings = window._NBSettings || {};
        window._NBSettings.apiKey = this.nbPublicKey;
        window._NBSettings.autoTrigger = false;
        window._NBSettings.feedback = false;

        const existing = document.querySelector("script[data-neverbounce-widget]");
        if (existing) {
          if (window._nb && window._nb.api) {
            this.nbLoaded = true;
            resolve();
          } else {
            existing.addEventListener("load", () => { this.nbLoaded = true; resolve(); });
            existing.addEventListener("error", reject);
          }
          return;
        }

        const script = document.createElement("script");
        script.src = NB_WIDGET_URL;
        script.async = true;
        script.setAttribute("data-neverbounce-widget", "true");
        script.addEventListener("load", () => { this.nbLoaded = true; resolve(); });
        script.addEventListener("error", reject);
        document.body.appendChild(script);
      });

      return this.nbLoadingPromise;
    }

    verifyEmail(email) {
      return new Promise((resolve, reject) => {
        if (!window._nb || !window._nb.api) { reject(new Error("NB not ready")); return; }

        const api = window._nb.api;
        const fn = typeof api.getValidatePublic === "function"
          ? api.getValidatePublic.bind(api)
          : (typeof api.single_check === "function" ? api.single_check.bind(api) : null);

        if (!fn) { reject(new Error("NB method missing")); return; }

        let settled = false;
        const timer = window.setTimeout(() => {
          if (settled) return;
          settled = true;
          reject(new Error("timeout"));
        }, NB_TIMEOUT_MS);

        fn(
          email,
          (result) => {
            if (settled) return;
            settled = true;
            window.clearTimeout(timer);
            resolve(result);
          },
          (err) => {
            if (settled) return;
            settled = true;
            window.clearTimeout(timer);
            reject(err);
          }
        );
      });
    }

    handleNBResult(result) {
      if (!result || typeof result.is !== "function") {
        this.nbLastResult = "unknown";
        this.setEmailStatus("", "");
        return;
      }

      // Result codes: 0=valid, 1=invalid, 2=disposable, 3=catchall, 4=unknown
      if (result.is(1)) {
        this.nbLastResult = "invalid";
        this.setEmailStatus("invalid", "");
        this.setFieldError("email", "This email address doesn't look valid. Please check for typos.");
        return;
      }

      if (result.is(2)) {
        this.nbLastResult = "invalid";
        this.setEmailStatus("invalid", "");
        this.setFieldError("email", "Please use a permanent email address (no disposable addresses).");
        return;
      }

      // valid / catchall / unknown — accept
      this.nbLastResult = "valid";
      this.setEmailStatus("valid", "");
      this.clearFieldError("email");
    }

    setEmailStatus(stateName, message) {
      if (!this.emailStatusEl) return;
      this.emailStatusEl.dataset.state = stateName || "";
      this.emailStatusEl.textContent = message || "";
    }

    open(trigger) {
      if (this.isOpen) return;
      this.lastFocusedElement = trigger || document.activeElement;

      const alreadySubmitted = this.isAlreadySubmitted();
      if (alreadySubmitted) {
        this.showState("already");
      } else {
        this.resetForm(true);
        this.showState("form");
      }

      this.modal.hidden = false;
      requestAnimationFrame(() => this.modal.classList.add("is-open"));

      this.lockScroll(true);
      document.addEventListener("keydown", this.handleKeydown);

      this.isOpen = true;
      this.focusInitial();

      if (this.nbPublicKey && !this.nbLoaded && !this.nbLoadingPromise) {
        this.loadNeverBounce().catch(() => {});
      }

      // Pre-fetch geolocation in the background — by submit time it will be ready
      if (!this.geoData && !this.geoPromise) {
        this.geoPromise = fetchGeolocation().then((result) => {
          this.geoData = result;
          return result;
        });
      }

      // --- Track: waitlist_form_open ---
      // Only fire for users who actually see the form (not the "already submitted" state)
      if (!alreadySubmitted) {
        pushToDataLayer({
          event: "waitlist_form_open",
          form_id: "kincern_waitlist_modal",
          trigger_text: (trigger && trigger.textContent || "").trim().slice(0, 80),
          trigger_location: (trigger && trigger.closest("[data-section-type]") && trigger.closest("[data-section-type]").getAttribute("data-section-type")) || "unknown",
          page_path: window.location.pathname
        });
      }
    }

    close() {
      if (!this.isOpen) return;
      this.modal.classList.remove("is-open");
      this.lockScroll(false);
      document.removeEventListener("keydown", this.handleKeydown);

      this.isOpen = false;
      window.setTimeout(() => {
        if (!this.isOpen) this.modal.hidden = true;
      }, 200);

      if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === "function") {
        this.lastFocusedElement.focus();
      }
    }

    handleKeydown(event) {
      if (!this.isOpen) return;
      if (event.key === "Escape") { event.preventDefault(); return; }
      if (event.key === "Tab") this.trapFocus(event);
    }

    trapFocus(event) {
      const activePanel = this.getActivePanel();
      if (!activePanel) return;

      const focusable = this.getFocusableElements(activePanel);
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const current = document.activeElement;

      if (event.shiftKey && current === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && current === last) {
        event.preventDefault();
        first.focus();
      }
    }

    getFocusableElements(container) {
      return Array.from(
        container.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )
      ).filter((el) => {
        if (el.hasAttribute("hidden")) return false;
        return el.offsetParent !== null || el === document.activeElement;
      });
    }

    getActivePanel() {
      return Object.values(this.statePanels).find((panel) => panel && !panel.hidden) || null;
    }

    showState(stateName) {
      Object.entries(this.statePanels).forEach(([name, panel]) => {
        if (!panel) return;
        panel.hidden = name !== stateName;
      });
      if (stateName === "form") this.clearSubmitError();
    }

    focusInitial() {
      // On touch devices, focus the dialog container (tabindex="-1") instead of
      // the first input. This prevents the mobile keyboard from popping up
      // immediately on modal open and blocking the form.
      if (isTouchDevice()) {
        if (this.dialog && typeof this.dialog.focus === "function") {
          this.dialog.focus({ preventScroll: true });
        }
        return;
      }

      const activePanel = this.getActivePanel();
      if (!activePanel) return;
      const first = this.getFocusableElements(activePanel)[0];
      if (first) first.focus();
    }

    validateAll() {
      let valid = true;
      if (!this.validateTextField("first_name", "First name is required.")) valid = false;
      if (!this.validateTextField("last_name", "Last name is required.")) valid = false;
      if (!this.validateEmailField()) valid = false;
      if (!this.validateAgeBracket()) valid = false;
      if (this.nbLastResult === "invalid") valid = false;
      return valid;
    }

    validateTextField(fieldName, message) {
      const input = this.form.elements[fieldName];
      if (!input) return true;
      const value = String(input.value || "").trim();
      if (!value) {
        this.setFieldError(fieldName, message);
        return false;
      }
      this.clearFieldError(fieldName);
      return true;
    }

    validateEmailField() {
      const input = this.emailInput;
      if (!input) return true;
      const value = String(input.value || "").trim();
      if (!value) {
        this.setFieldError("email", "Email address is required.");
        return false;
      }
      if (!input.checkValidity()) {
        this.setFieldError("email", "Enter a valid email address.");
        return false;
      }
      return true;
    }

    validateAgeBracket() {
      const selected = this.form.querySelector('input[name="age_bracket"]:checked');
      if (!selected) {
        this.setFieldError("age_bracket", "Select an age bracket.");
        return false;
      }
      this.clearFieldError("age_bracket");
      return true;
    }

    setFieldError(fieldName, message) {
      const errorEl = this.root.querySelector(`[data-error-for="${fieldName}"]`);
      if (errorEl) errorEl.textContent = message;

      if (fieldName === "age_bracket") {
        this.form.querySelectorAll('input[name="age_bracket"]').forEach((r) => {
          r.setAttribute("aria-invalid", "true");
        });
        return;
      }

      const field = this.form.elements[fieldName];
      if (field && typeof field.setAttribute === "function") {
        field.setAttribute("aria-invalid", "true");
      }
    }

    clearFieldError(fieldName) {
      const errorEl = this.root.querySelector(`[data-error-for="${fieldName}"]`);
      if (errorEl) errorEl.textContent = "";

      if (fieldName === "age_bracket") {
        this.form.querySelectorAll('input[name="age_bracket"]').forEach((r) => {
          r.removeAttribute("aria-invalid");
        });
        return;
      }

      const field = this.form.elements[fieldName];
      if (field && typeof field.removeAttribute === "function") {
        field.removeAttribute("aria-invalid");
      }
    }

    getFormValues() {
      const data = new FormData(this.form);
      return {
        first_name: String(data.get("first_name") || "").trim(),
        last_name: String(data.get("last_name") || "").trim(),
        email: String(data.get("email") || "").trim().toLowerCase(),
        age_bracket: String(data.get("age_bracket") || "").trim()
      };
    }

    async submit() {
      if (this.isSubmitting) return;
      if (!this.validateAll()) {
        const firstInvalid = this.form.querySelector('[aria-invalid="true"]');
        if (firstInvalid && typeof firstInvalid.focus === "function") firstInvalid.focus();
        return;
      }

      if (!this.klaviyoKey || !this.klaviyoListId) {
        this.showSubmitError("Configuration error: Klaviyo API Key or List ID is missing. Please add them in the theme editor.");
        return;
      }

      this.clearSubmitError();
      this.setSubmitting(true);

      const values = this.getFormValues();
      const metadata = collectMetadata();
      const geo = this.geoData || (this.geoPromise ? await this.geoPromise.catch(() => ({ country: "", city: "", region: "" })) : { country: "", city: "", region: "" });

      const klaviyoProps = {
        "Age Bracket": values.age_bracket,
        "Signup Page": window.location.href,
        "Device": metadata.device,
        "Browser": metadata.browser,
        "Operating System": metadata.os,
        "Screen Size": metadata.screenSize,
        "Referrer": metadata.referrer,
        "Browser Language": metadata.language,
        "Signup Time Bucket": metadata.signupTime
      };
      if (geo.country) klaviyoProps["Country"] = geo.country;
      if (geo.city) klaviyoProps["City"] = geo.city;
      if (geo.region) klaviyoProps["Region"] = geo.region;
      if (metadata.utmSource) klaviyoProps["UTM Source"] = metadata.utmSource;
      if (metadata.utmMedium) klaviyoProps["UTM Medium"] = metadata.utmMedium;
      if (metadata.utmCampaign) klaviyoProps["UTM Campaign"] = metadata.utmCampaign;
      if (metadata.utmTerm) klaviyoProps["UTM Term"] = metadata.utmTerm;
      if (metadata.utmContent) klaviyoProps["UTM Content"] = metadata.utmContent;

      const payload = {
        data: {
          type: "subscription",
          attributes: {
            custom_source: "Waitlist Modal",
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: values.email,
                  first_name: values.first_name,
                  last_name: values.last_name,
                  properties: klaviyoProps
                }
              }
            }
          },
          relationships: {
            list: { data: { type: "list", id: this.klaviyoListId } }
          }
        }
      };

      try {
        const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${this.klaviyoKey}`, {
          method: "POST",
          headers: { "Content-Type": "application/json", "revision": "2024-02-15" },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          let errorMessage = "We could not submit the form. Please try again.";
          try {
            const errorJson = await response.json();
            if (errorJson.errors && errorJson.errors.length > 0) {
              errorMessage = errorJson.errors[0].detail || errorMessage;
            }
          } catch (e) {}
          throw new Error(errorMessage);
        }

        // Klaviyo succeeded — fire Teams notification (non-blocking)
        this.sendTeamsNotification(values, metadata, geo).catch(() => {});

        await this.persistSubmission(values.email);

        // --- Track: waitlist_form_submit (Meta "Lead", GA4 "generate_lead") ---
        // Fire BEFORE showState so the event sits next to the conversion intent.
        pushToDataLayer({
          event: "waitlist_form_submit",
          event_id: generateEventId("lead"),
          form_id: "kincern_waitlist_modal",
          // Contact fields — used by Meta Pixel for Advanced Matching / EMQ
          lead_email: values.email,
          lead_first_name: values.first_name,
          lead_last_name: values.last_name,
          // Business data
          age_bracket: values.age_bracket,
          // Attribution
          utm_source: metadata.utmSource || "(direct)",
          utm_medium: metadata.utmMedium || "(none)",
          utm_campaign: metadata.utmCampaign || "(none)",
          utm_content: metadata.utmContent || "",
          utm_term: metadata.utmTerm || "",
          referrer_domain: metadata.referrer || "(direct)",
          // Context
          device: metadata.device,
          browser: metadata.browser,
          country: (geo && geo.country) || "",
          city: (geo && geo.city) || "",
          region: (geo && geo.region) || ""
        });

        this.showState("success");

        const closeButton = this.statePanels.success.querySelector("[data-waitlist-close]");
        if (closeButton) closeButton.focus();
      } catch (error) {
        this.showSubmitError(error && error.message ? error.message : "Something went wrong. Please try again.");
      } finally {
        this.setSubmitting(false);
      }
    }

    sendTeamsNotification(values, metadata, geo) {
      if (!this.teamsWebhook) return Promise.resolve();

      const locationStr = [geo.city, geo.region, geo.country].filter(Boolean).join(", ") || "Unknown";
      const utmStr = [
        metadata.utmSource && ("source: " + metadata.utmSource),
        metadata.utmMedium && ("medium: " + metadata.utmMedium),
        metadata.utmCampaign && ("campaign: " + metadata.utmCampaign)
      ].filter(Boolean).join(" · ") || "None";

      const card = {
        type: "message",
        attachments: [{
          contentType: "application/vnd.microsoft.card.adaptive",
          contentUrl: null,
          content: {
            $schema: "http://adaptivecards.io/schemas/adaptive-card.json",
            type: "AdaptiveCard",
            version: "1.4",
            msteams: { width: "Full" },
            body: [
              { type: "TextBlock", size: "Large", weight: "Bolder", text: "New Kincern waitlist signup" },
              { type: "TextBlock", text: values.first_name + " " + values.last_name, weight: "Bolder", size: "Medium", spacing: "Small" },
              { type: "TextBlock", text: values.email, isSubtle: true, spacing: "None" },
              { type: "FactSet", spacing: "Medium", facts: [
                { title: "Age bracket of wearer:", value: values.age_bracket || "—" },
                { title: "Location:", value: locationStr },
                { title: "Device:", value: metadata.device + " · " + metadata.os },
                { title: "Browser:", value: metadata.browser + " (" + metadata.language + ")" },
                { title: "Referrer:", value: metadata.referrer },
                { title: "Signup page:", value: window.location.href },
                { title: "UTMs:", value: utmStr }
              ]}
            ]
          }
        }]
      };

      return fetch(this.teamsWebhook, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(card)
      });
    }

    setSubmitting(isSubmitting) {
      this.isSubmitting = isSubmitting;
      this.root.querySelectorAll("[data-waitlist-submit]").forEach((b) => { b.disabled = isSubmitting; });
      if (this.submitLabel) this.submitLabel.hidden = isSubmitting;
      if (this.submitLoading) this.submitLoading.hidden = !isSubmitting;
    }

    showSubmitError(message) {
      if (!this.submitError) return;
      this.submitError.textContent = message;
      this.submitError.hidden = false;
    }

    clearSubmitError() {
      if (!this.submitError) return;
      this.submitError.textContent = "";
      this.submitError.hidden = true;
    }

    resetForm(clearValues) {
      if (clearValues) this.form.reset();
      this.root.querySelectorAll("[data-error-for]").forEach((el) => { el.textContent = ""; });
      this.form.querySelectorAll('[aria-invalid="true"]').forEach((el) => el.removeAttribute("aria-invalid"));
      this.clearSubmitError();
      this.setSubmitting(false);
      this.nbLastCheckedEmail = null;
      this.nbLastResult = null;
      this.setEmailStatus("", "");
    }

    lockScroll(locked) {
      if (locked) {
        this.scrollY = window.scrollY || window.pageYOffset || 0;
        document.documentElement.classList.add("waitlist-modal-open");
        document.body.classList.add("waitlist-modal-open");
        document.body.style.position = "fixed";
        document.body.style.top = `-${this.scrollY}px`;
        document.body.style.left = "0";
        document.body.style.right = "0";
        document.body.style.width = "100%";
        return;
      }
      document.documentElement.classList.remove("waitlist-modal-open");
      document.body.classList.remove("waitlist-modal-open");
      const savedY = Math.abs(parseInt(document.body.style.top || "0", 10)) || this.scrollY || 0;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      window.scrollTo(0, savedY);
    }

    isAlreadySubmitted() {
      return this.storageGet(STORAGE_KEYS.submitted) === "true";
    }

    clearSubmissionMemory() {
      this.storageRemove(STORAGE_KEYS.submitted);
      this.storageRemove(STORAGE_KEYS.submittedAt);
      this.storageRemove(STORAGE_KEYS.emailHash);
    }

    getAnonymousId() {
      const existing = this.storageGet(STORAGE_KEYS.anonymousId);
      if (existing) return existing;
      let id = "";
      if (window.crypto && typeof window.crypto.randomUUID === "function") {
        id = window.crypto.randomUUID();
      } else {
        id = `wl-${Date.now()}-${Math.random().toString(16).slice(2, 10)}`;
      }
      this.storageSet(STORAGE_KEYS.anonymousId, id);
      return id;
    }

    async persistSubmission(email) {
      const submittedAt = new Date().toISOString();
      this.storageSet(STORAGE_KEYS.submitted, "true");
      this.storageSet(STORAGE_KEYS.submittedAt, submittedAt);
      const hash = await this.sha256Hex(email);
      if (hash) this.storageSet(STORAGE_KEYS.emailHash, hash);
    }

    async sha256Hex(value) {
      if (!window.crypto || !window.crypto.subtle) return "";
      const normalized = String(value || "").trim().toLowerCase();
      if (!normalized) return "";
      const bytes = new TextEncoder().encode(normalized);
      const hashBuffer = await window.crypto.subtle.digest("SHA-256", bytes);
      return Array.from(new Uint8Array(hashBuffer))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
    }

    storageGet(key) {
      try { return window.localStorage.getItem(key); } catch (_) { return null; }
    }

    storageSet(key, value) {
      try { window.localStorage.setItem(key, value); } catch (_) {}
    }

    storageRemove(key) {
      try { window.localStorage.removeItem(key); } catch (_) {}
    }
  }

  function initWaitlistModal() {
    if (window.__waitlistModalInstance) return;
    const root = document.querySelector("[data-waitlist-root]");
    if (!root) return;
    const instance = new WaitlistModal(root);
    instance.init();
    window.__waitlistModalInstance = instance;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initWaitlistModal);
  } else {
    initWaitlistModal();
  }
})();